import React from 'react'
import { Link } from 'react-router-dom'

export const removeDuplicateClasses = (baseClasses, overrideClasses) => {
  const baseClassList = baseClasses.split(' ')
  const overrideClassList = overrideClasses.split(' ')

  const classGroups = [
    'h-',
    'w-',
    'text-',
    'bg-',
    'p-',
    'm-',
    'flex',
    'justify-',
    'items-',
    'rounded',
  ]

  const filteredBaseClasses = baseClassList.filter((baseClass) => {
    return !classGroups.some((group) =>
      overrideClassList.some(
        (overrideClass) =>
          overrideClass.startsWith(group) && baseClass.startsWith(group)
      )
    )
  })

  return [...filteredBaseClasses, ...overrideClassList].join(' ')
}

const PrimaryButton = ({
  children,
  to,
  onClick,
  disabled = false,
  className = '',
  ...props
}) => {
  const baseClasses =
    'h-[50px] text-center font-bold py-2 px-4 rounded focus:bg-primary-700 flex justify-center items-center'
  const activeClass = 'bg-primary hover:bg-primary-600 text-white'
  const disableClass = 'bg-primary-100 text-primary-400'
  const combinedClasses = removeDuplicateClasses(
    `${disabled ? disableClass : activeClass} ${baseClasses}`,
    className
  )

  if (to) {
    return (
      <Link to={to} className={combinedClasses} {...props}>
        {children}
      </Link>
    )
  }

  return (
    <button
      onClick={onClick}
      className={combinedClasses}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
